$(document).on('click', '.quickview-pdp', function(){
    var loadingBar = $('.LoadingBar');
    var $this = $(this);
    var productId = $(this).data('product-id');
    var productHandle =  $(this).data('product-handle');
    var productUrl = '/products/'+productHandle;
    $.ajax({
        type : "GET",
        url : `/products/${productHandle}`,
        beforeSend: function(){
            loadingBar.addClass('popup-loading');
        },
        success: function(response){
            var reponsePdp = $(response).find('section.Product').html();
            $('.quick-view-popup').find('.quick-view-inner').html(reponsePdp);
            initializeFlickity();
            loadingBar.addClass('popup-loaded');
            setTimeout(function(){
                loadingBar.removeClass('popup-requested popup-loaded popup-loading');
            },1000)
            $('.quick-view-popup').addClass('active');
            $('body').addClass('quick-view-activated');

            var optionOneValue = $('.HorizontalList__Item input[name="option-0"]:checked').val();
            $('.HorizontalList__Item input[name="option-0"]').change(function(){
                if ($(this).is(':checked')) {
                    optionOneValue = $(this).val();
                }
            })
            var optionTwoValue = $('.HorizontalList__Item input[name="option-1"]:checked').val();;
            $('.HorizontalList__Item input[name="option-1"]').change(function(){
                if ($(this).is(':checked')) {
                    optionTwoValue = $(this).val();
                }
            })
            $('.HorizontalList__Item input').change(function(){
                var checkedValue = optionOneValue + ' / ' + optionTwoValue;
                $('.productselectors option').each(function(){
                    if ($(this).text().includes(checkedValue)) {
                        $(this).attr('selected',true)
                    }
                })
            })

            $('.HorizontalList__Item input').each(function() {
                if ($(this).is(':checked')) {
                    console.log($(this).val());
                }
            });

            $('.ProductForm__BuyButtons').removeClass('lensActive');
            $('lensadvizor-quick-buy').addClass('hidelens');
            $('.ProductForm__BuyButtons').append(`<a href="${productUrl}" class="Button Button--primary prescriptionRedirect">ADD Prescription</a>`)
            $.ajax({
                type: "GET",
                url: productUrl + '.json',
                success: function(response) {
                    var thumbSlider = '';
                    response.product.images.forEach(function(image) {
                    thumbSlider += `
                        <div class="navigationthumbnail--media carousel-cell">
                            <img src="${image.src}" loading="lazy" width="100" height="100" alt="">
                        </div>`;
                    });
            
                    $('.quick-view-container .Product__Gallery').append(`<div class="thumbnail--slider-product">${thumbSlider}</div>`);
                    initializeThumbanil();
                },
                error: function(xhr, status, error) {
                    console.error("An error occurred: " + error);
                }
            });
        }
    });
});

$(document).on('click', '.close-quickview', function(){
    $('.quick-view-popup').removeClass('active');
    $('body').removeClass('quick-view-activated');
    $('.quick-view-popup').find('.quick-view-inner').html('');
});

$(document).on('click', function(e) {
    if (!$(e.target).closest('.quick-view-popup, .quickview-pdp').length) {
        $('.quick-view-popup').removeClass('active');
        $('body').removeClass('quick-view-activated');
        $('.quick-view-popup').find('.quick-view-inner').html('');
    }
});


function initializeFlickity() {
    $('.quick-view-inner .Carousel').flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        wrapAround: true
    });
}
function initializeThumbanil() {
    $('.thumbnail--slider-product').flickity({
        asNavFor : ".quick-view-inner .Carousel",
        contain: true,
        pageDots: false,
        wrapAround: true
    });
}